'use client';

import { Pause, Play } from 'lucide-react';

import React from 'react';

import { cn } from '@/lib/utils';

import { useHLSPlayer } from '../contexts/hls-player-provider';
import type { IControlsProps } from '../types';

function PlayPauseButton({ className }: IControlsProps) {
	const { playbackState, togglePlay } = useHLSPlayer();
	const { isPlaying } = playbackState;

	return (
		<button
			onClick={togglePlay}
			className={cn(
				'flex size-7 items-center justify-center rounded-md text-white transition-colors hover:bg-white/20',
				className
			)}
			aria-label={isPlaying ? 'Pause' : 'Play'}
		>
			{isPlaying ? <Pause size={16} /> : <Play size={16} />}
		</button>
	);
}

export default React.memo(PlayPauseButton);
